import { CdkTableModule } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FuseSharedModule } from '@fuse/shared.module';
import { PipesModule } from '../../pipes/pipes.module';
import { CadMaterialsLinkDialogComponent } from './cadmaterials-link-dialog/cadmaterials-link-dialog.component';
import { CadmodelMatLinkGlanceDialogComponent } from './cadmodel-mat-link-glance-dialog/cadmodel-mat-link-glance-dialog.component';
import { ModelReadSettingsDialogComponent } from './model-read-settings-dialog/model-read-settings-dialog.component';
import { OrderFileDetailDialogComponent } from './order-file-detail-dialog/order-file-detail-dialog.component';

import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { CadModelMaterialsMatchingModule } from '../cadmodel-materials-matching/cadmodel-materials-matching.module';
import { CadModelDetailsDialogComponent } from './cadmaterials-list-dialog/cadmodel-details-dialog.component';
import { OrderModelsComponent } from './order-models.component';
import { SemifinishedProductTypeSettingDialogComponent } from './semifinished-product-type-setting-dialog/semifinished-product-type-setting-dialog.component';

@NgModule({
  imports: [
    MatTableModule,
    CdkTableModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatToolbarModule,
    MatDividerModule,
    MatTabsModule,
    MatCheckboxModule,
    MatSortModule,
    MatTooltipModule,
    MatMenuModule,
    CadModelDetailsDialogComponent,

    MatSnackBarModule,

    PipesModule,
    FuseSharedModule,
    CadModelMaterialsMatchingModule,
  ],
  exports: [OrderModelsComponent],
  declarations: [
    OrderModelsComponent,
    SemifinishedProductTypeSettingDialogComponent,
    OrderFileDetailDialogComponent,
    CadmodelMatLinkGlanceDialogComponent,
    CadMaterialsLinkDialogComponent,
    ModelReadSettingsDialogComponent,
  ],
  providers: [],
})
export class OrderModelsModule {}
